// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.files-container {
  margin-top: 10px;
  text-align: center;
  overflow: hidden;
  position: relative;
}
.files-container .no-files {
  text-align: center;
  opacity: 0.5;
  margin: 2rem 0;
}

::ng-deep.upload-file-component {
  position: absolute;
  height: 100%;
  width: 100%;
}

.file-drag-drop-area {
  background-color: white;
  min-height: 170px;
  border-radius: 4px;
  background-color: #fbfbfb;
  border: dashed 2px #dcdcdc;
  position: relative;
  overflow: hidden;
}

.drag-drop-text {
  margin-top: 4rem;
  margin-bottom: 4rem;
  text-align: center;
  color: rgb(194, 194, 194);
}

.upload-button-container {
  text-align: center;
  margin: 0 auto;
  width: 100%;
  left: 0;
}

.disabled-pointer-events {
  pointer-events: none;
  opacity: 0.8;
}

.file-preview-area {
  margin: 1rem;
}
.file-preview-area .file-uploader-container {
  background: white;
  padding: 0.5rem 1rem;
}
.file-preview-area .files-view {
  padding: 1rem;
  margin: 1rem;
}
.file-preview-area .card-link {
  word-break: break-all;
}
.file-preview-area .drag-drop-container {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 60px;
}

.image-preview {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 200px;
  margin: 1rem;
}

.hidden-file-input {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/multiple-attachments-field/multiple-attachments-field.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,YAAA;EACA,cAAA;AACJ;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAAF;;AAGA;EACE,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,OAAA;AAAF;;AAGA;EACE,oBAAA;EACA,YAAA;AAAF;;AAGA;EACE,YAAA;AAAF;AAGE;EACE,iBAAA;EACA,oBAAA;AADJ;AAIE;EACE,aAAA;EACA,YAAA;AAFJ;AAKE;EACE,qBAAA;AAHJ;AAME;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;AAJJ;;AAQA;EACE,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,aAAA;EACA,YAAA;AALF;;AAQA;EACE,UAAA;AALF","sourcesContent":[".files-container {\n  margin-top: 10px;\n  text-align: center;\n  overflow: hidden;\n  position: relative;\n\n  .no-files {\n    text-align: center;\n    opacity: 0.5;\n    margin: 2rem 0;\n  }\n}\n\n::ng-deep.upload-file-component {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n\n.file-drag-drop-area {\n  background-color: white;\n  min-height: 170px;\n  border-radius: 4px;\n  background-color: #fbfbfb;\n  border: dashed 2px #dcdcdc;\n  position: relative;\n  overflow: hidden;\n}\n\n.drag-drop-text {\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n  text-align: center;\n  color: rgb(194, 194, 194);\n}\n\n.upload-button-container {\n  text-align: center;\n  margin: 0 auto;\n  width: 100%;\n  left: 0;\n}\n\n.disabled-pointer-events {\n  pointer-events: none;\n  opacity: 0.8;\n}\n\n.file-preview-area {\n  margin: 1rem;\n\n\n  .file-uploader-container {\n    background: white;\n    padding: 0.5rem 1rem;\n  }\n\n  .files-view {\n    padding: 1rem;\n    margin: 1rem;\n  }\n\n  .card-link {\n    word-break: break-all;\n  }\n\n  .drag-drop-container {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 60px;\n  }\n}\n\n.image-preview {\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 200px;\n  margin: 1rem;\n}\n\n.hidden-file-input {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
